import { ASYNC, SYNC, actionTypes } from "../utils"
import { AsyncRequestStatus } from "../utils/reduxTypes"

type communityActionTypes = {
  community: {
    FETCH_COMMUNITIES: AsyncRequestStatus
    SET_FILTER_VALUE: string
  }
}

const types = actionTypes({
  community: {
    FETCH_COMMUNITIES: ASYNC,
    SET_FILTER_VALUE: SYNC,
  },
}) as communityActionTypes

export default types.community

export type TCommunity = {
  country: string
  lead: string
  leadSupport?: string[]
  region: string
}

export type TCountryFunctionOwners = {
  countryCode: string
  functionOwner: {
    name: string
    email: string
  }
}

export type TOptContentOwnership = {
  global: boolean
  type: string[]
  title: string
  opfId: string
  id: string
  globalFunctionOwner?: {
    email?: string
    name?: string
  }
  countryFunctionOwners?: TCountryFunctionOwners[]
  // computed
  countryTableData?: IOwnershipTableItem[]
}

export type CommunityState = {
  communities: TCommunity[]
  communitiesContentOwnership: {
    functions: TOptContentOwnership[]
  }
  loading: boolean
  error?: boolean
  filters: {
    functionValue?: string
    countryValues?: string[]
    levelValues?: string[]
  }
}

export interface IOwnershipTableItem {
  country: string
  countryCode: string
  ownerName?: string
  ownerEmail?: string
}
